import { message } from 'antd'
import { LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL, NOTIFICATION_MESSAGE_DURATION } from '../config/constants'
import history from '../routers/history'
import store from 'store'

export const basicNotification = (textToShow, duration = NOTIFICATION_MESSAGE_DURATION) => {
  return message.info(message, duration)
}

export const errorNotification = (textToShow, duration = NOTIFICATION_MESSAGE_DURATION) => {
  return message.error(textToShow, duration)
}

export const successNotification = (textToShow, duration = NOTIFICATION_MESSAGE_DURATION) => {
  return message.success(textToShow, duration)
}

export const warningNotification = (textToShow, duration = NOTIFICATION_MESSAGE_DURATION) => {
  return message.warning(textToShow, duration)
}

export const dataLoadingNotification = (textToShow) => {
  return message.loading(textToShow, 0)
}

export const clearNotification = () => {
  message.destroy()
}

export const checkAuthorizationError = (errorMessage) => {
  if(errorMessage==='401'){
    if(history && history.location && history.location.pathname){
      store.set(LOCAL_STORAGE_POST_LOGIN_REDIRECT_URL, history.location.pathname)
      errorNotification('Token Expired')
      history.replace({ pathname: '/login', search: history.location.search })
    }
  }
}